import { render, staticRenderFns } from "./LayoutBlank.vue?vue&type=template&id=6f5d35e9&"
import script from "./LayoutBlank.vue?vue&type=script&lang=js&"
export * from "./LayoutBlank.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBlank.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../landing-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports